import { http } from '@/utils/http';
import qs from 'qs';
const baseURL = '/vote/2019poject/2019community/controller.php?enews=';

// 基础信息
export const baseInfo = () => {
  return http.post(`${baseURL}base-info`);
};

// 根据type类型 获取列表数据
export const getlist = (type: any, page: any) => {
  return http.post(`${baseURL}vote-list&type=${type}&page=${page}`);
};

/**
 * 投票接口
 */
export const vote = (data: {
  id: number | string;
  type: number | string;
  num: number | string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${baseURL}vote`, qsData);
};

// 搜索列表接口
export const searchData = (type: any, page: any, data: any) => {
  return http.get(
    `${baseURL}vote-list&search=${data}&type=${type}&page=${page}`,
  );
};

// 详情页面接口
export const detailPage = (data: any) => {
  return http.get(`${baseURL}detail&type=${data.type}&id=${data.id}`);
};

// 充值记录接口
export const topUpRecord = () => {
  return http.get(`${baseURL}recharge`);
};

// 消费记录
export const expenditureRecord = () => {
  return http.get(`${baseURL}consumption`);
};

// 消费，充值记录列表
export const recordList = (param: string, page: number) => {
  return http.get(`${baseURL}${param}&page=${page}`);
};

// 余额接口
export const balance = () => {
  return http.get(`${baseURL}voteNum`);
};

// 用户信息接口
export const userInfo = () => {
  return http.get(`${baseURL}user-info`);
};

export interface TopUpParam {
  WIDout_trade_no: string | number;
  userid: string | number;
  username: string;
  WIDtotal_amount: number;
}
